'use client';

import { useEffect, useState } from "react";
import PAGE_INFO from "../../../constants/siteInfo/pageInfo";
import useGetPageListForBreadCrumbs from "../../../hooks/useGetPageListForBreadCrumbs.hooks";
import styles from "./Breadcrumbs.module.scss";

const Breadcrumbs = () => {

  const [currentPath, setCurrentPath] = useState("");

  useEffect(() => {
    setCurrentPath(decodeURIComponent(window.location.pathname))
  },[])

  const pathList = useGetPageListForBreadCrumbs(currentPath, PAGE_INFO);

  return (
    <>
      {/* debug code */}
      {/* {JSON.stringify(pathList)} */}
      <div className={styles.Breadcrumbs}>
        <ol itemScope itemType={"http://schema.org/BreadcrumbList"} id={"breadcrumbs"} className={styles.Breadcrumbs__inner}>
          {pathList.map((path, index) => (
            <li key={index} itemProp="itemListElement" itemScope itemType={"http://schema.org/ListItem"} >
              {path.slug === '/' ? (
                <>
                  <a href="/" itemProp="item"><span itemProp="name">{path.title}</span></a>
                  <meta itemProp="position" content={(index+1).toString()} />
                </>
              ) : (
                <>
                  <a href={`/${path.slug}/`} itemProp="item"><span itemProp="name">{path.title}</span></a>
                  <meta itemProp="position" content={(index+1).toString()} />
                </>
              )}
            </li>
          ))}
        </ol>
      </div>
    </>
  )
}

export default Breadcrumbs;